var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material';
export var FormLayout = function (_a) {
    var children = _a.children, className = _a.className, itemStyle = _a.itemStyle, _b = _a.gap, gap = _b === void 0 ? '1rem' : _b;
    return _jsx(Root, __assign({}, { className: className, itemStyle: itemStyle, gap: gap }, { children: children }));
};
var Root = styled('div', {
    shouldForwardProp: function (prop) { return prop !== 'itemStyle'; },
})(function (_a) {
    var itemStyle = _a.itemStyle, gap = _a.gap;
    return ({
        padding: '2rem',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'stretch',
        '--gap': gap,
        gap: 'var(--gap)',
        '&& > *': __assign({ minWidth: 'max(200px, calc(50% - var(--gap)))', flex: '1' }, itemStyle),
    });
});
